
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2053_18144)"}},[_c('path',{attrs:{"d":"M20 5.344H4.625V1.609c0-.5.406-.906.906-.906h13.547c.5 0 .906.406.906.906v3.735H20z","fill":"#E9EEEF"}}),_c('path',{attrs:{"d":"M20 5.344H4.625V10H20V5.344z","fill":"#B3BBBF"}}),_c('path',{attrs:{"d":"M20 10H4.625v4.656H20V10z","fill":"#9EA7AB"}}),_c('path',{attrs:{"d":"M19.094 19.297H5.547a.907.907 0 01-.906-.906v-3.735H20v3.735c0 .5-.406.906-.906.906z","fill":"#738181"}}),_c('path',{attrs:{"d":"M9.281 15.156H1c-.547 0-1-.453-1-1V6c0-.547.453-1 1-1h8.281c.547 0 1 .453 1 1v8.156c0 .547-.437 1-1 1z","fill":"#728181"}}),_c('path',{attrs:{"opacity":".2","d":"M10.297 5.828v8.25c0 .547-.453 1-1 1H4.64v.89h5.5c.546 0 1-.452 1-1V6.814c0-.5-.36-.922-.844-.985z","fill":"#000"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","d":"M1.5 9.5h7M1.5 7.5h7M1.5 11.5h4"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2053_18144"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    